class SessionStateManager{

    /**
     * Indicates the key for the session
     */
    key;

    /**
     * The session state
     */
    _sessionState;

    constructor(key ,restore){

        //  always lower cased
        this.key = key.toLowerCase();

        if(restore === true){
            this.restore();
        }
        else{

            //  set empty state
            this._sessionState = {};
        }
    }

    /**
     * Saves an item to session storage
     * @param key
     * @param value
     */
    putState(key,value){

        if(this._sessionState){
            this._sessionState[key] = value;
        }

        return this;
    }

    /**
     * Gets a saved state item
     * @param key
     * @param defValue
     * @returns {*}
     */
    getState(key,defValue){

        if(this._sessionState){

            if(this._sessionState.hasOwnProperty(key))
                return this._sessionState[key];
        }


        return defValue === undefined ? null : defValue;
    }

    /**
     * Saves all the state values within the frame supplied
     * @param stateFrame
     */
    putStateFrame(stateFrame){

        if(this._sessionState) {
            for (let item in stateFrame) {

                if(stateFrame.hasOwnProperty(item))
                    this._sessionState[item] = stateFrame[item];

            }
        }

        return this;
    }

    /**
     * Saves the current session to storage
     */
    save(){

        window.sessionStorage.setItem(this.key, JSON.stringify(this._sessionState));
        return this;
    }

    /**
     * Clears current session state
     */
    reset(){
        window.sessionStorage.removeItem(this.key);
        this._sessionState = {};
    }

    /**
     * Restore Session State
     */
    restore(){

        let value;
        let state =  window.sessionStorage.getItem(this.key);
        if(state == null || state === "undefined")
            value = {};
        else
            value = JSON.parse(state);

        this._sessionState = value;
    }


    static invalidateSession(name){

        //  Clears corresponding session data
        window.sessionStorage.removeItem(name);

    }
}

export default SessionStateManager;


// WEBPACK FOOTER //
// ./src/common/SessionStateManager.js